// extracted by mini-css-extract-plugin
export default {"parent":"navbar_parent__ePmgj","item":"navbar_item__0B43N","inputBox":"navbar_inputBox__rcJbc","inputSerche":"navbar_inputSerche__Tip92","iconSerche":"navbar_iconSerche__Xt3Wk"};